import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];
const D = 0.3;

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ y }}
    whileInView={{ y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: D, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className = "", delay = 0 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-40px" }}
    transition={{ staggerChildren: 0.06, delayChildren: delay }}
  >
    {children}
  </motion.div>
);

export const Item = ({ children, className = "", y = 20 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { y },
      show: { y: 0, transition: { duration: D, ease: EASE } },
    }}
  >
    {children}
  </motion.div>
);

export const WordReveal = ({ text, className = "", delay = 0 }) => (
  <motion.span
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-40px" }}
    transition={{ staggerChildren: 0.05, delayChildren: delay }}
  >
    {text.split(" ").map((w, i, arr) => (
      <motion.span
        key={i}
        className="inline-block"
        variants={{ hidden: { y: 14 }, show: { y: 0, transition: { duration: D, ease: EASE } } }}
      >
        {w}{i < arr.length - 1 ? " " : ""}
      </motion.span>
    ))}
  </motion.span>
);

export const SectionLabel = ({ children }) => (
  <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-pop">
    <span className="inline-block h-px w-8 bg-myrtle" aria-hidden="true" />
    {children}
  </p>
);
